<p-toast></p-toast>

<p-dialog [(visible)]="isVisibleImageModal" *ngIf="isVisibleImageModal" [modal]="true" [style]="{ width: '50vw', height: 'calc(100vh - 210px)' }" [draggable]="false" [resizable]="false">
    <p-carousel [value]="imageArray" [numVisible]="1" [numScroll]="1" verticalViewPortHeight="360px">
        <ng-template let-image pTemplate="item">
            <div class="mb-3">
                <ng-container *ngIf="isPdfFile">
                    <iframe [src]="image" [style]="{ width: '100%', height: 'calc(100vh - 370px)' }"></iframe>
                </ng-container>
                <img src="{{ image }}" *ngIf="!isPdfFile" class="document-image" />
            </div>
        </ng-template>
    </p-carousel>
</p-dialog>

<p-sidebar [(visible)]="isVisibleOwnerInfoDetail"
           [position]="'right'"
           [baseZIndex]="11000"
           (onHide)="cancel()"
           [style]="{width:'500px'}">

    <ng-template pTemplate="header">
        <div style="display: flex; flex-direction: column">
            <div class="header-vehicle-info">{{ ownerVehicleDetailData.vehicle.VehicleModel }} {{ ownerVehicleDetailData.vehicle.VehicleModelSeries }} {{ ownerVehicleDetailData.vehicle.NumberPlate }}</div>
            <div class="header-subtitle">Vehicle Details</div>
        </div>
    </ng-template>
    <ng-template pTemplate="body">
        <div class="order-customer-block">
            <div class="lm-active-order-details-field-block">
                <div class="lm-active-order-details-field-name">Owner’s Name:</div>
                <div class="lm-active-order-details-field-value">{{ ownerVehicleDetailData.vehicle.OwnerFirstName }} {{ ownerVehicleDetailData.vehicle.OwnerLastName }}</div>
            </div>
            <div class="lm-active-order-details-field-block">
                <div class="lm-active-order-details-field-name">Phone Number:</div>
                <div class="lm-active-order-details-field-value">{{ ownerVehicleDetailData.vehicle.OwnerPhone }}</div>
            </div>
        </div>
    </ng-template>
</p-sidebar>